import { useEffect, useRef, useState } from 'react';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import { createPortal } from 'react-dom';
import "./css/Modal.css"
import { env } from '../../../env';

let modalCount = 0;

interface Props {
  children: any;
  modal: any;
  eventModal?: any;
  updateModal: any;
  onSubmitLabel?: string;
  evenOnClose?: any;
  buttonsAddFooter?: React.ReactNode;
}

export const Modal = ({
  children,
  modal,
  eventModal,
  updateModal,
  onSubmitLabel,
  evenOnClose,
  buttonsAddFooter,
}: Props) => {
  const [visible, setVisible] = useState(false);
  const prevViewRef = useRef(modal.view);
  const [zIndex, setZIndex] = useState(1040);

  useEffect(() => {
    setVisible(modal.view);
    if (modal.view) {
      modalCount++;
      setZIndex(1040 + modalCount * 10);
    }
    return () => {
      setVisible(false);
      if (modal.view) {
        modalCount--;
      }
    };
  }, [modal.view]);

  useEffect(() => {
    if (prevViewRef.current === true && modal.view === false) {
      evenOnClose && evenOnClose(true);
    }

    prevViewRef.current = modal.view;
  }, [modal.view]);

  if (!modal.view) return null;

  const isMobile = _single.getIsMovil();
  const isTest = env.TEST_ENVIROMENT ?? false;

  const modalContent = (
    <>
      <div
        className={`modal fade show ${modal.format} ${isTest ? 'test-environment-modal' : ''} animate__animated animate__fadeIn`}
        // tabIndex={modal.tabIndex}
        style={{ display: 'block', zIndex: zIndex + 1 }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content modal-mobile-fix">

            {/* HEADER */}
            <div className={`modal-header ${modal.styles?.headerClass ?? ''}`}>
              <h5 className="modal-title">{modal.name}</h5>

              <div className="d-flex align-items-center gap-2">
                {!isMobile && (
                  <div className="dropdown">
                    <i
                      className="ri-aspect-ratio-line fs-5 cursor-pointer"
                      role="button"
                      data-bs-toggle="dropdown"
                    ></i>

                    <ul className="dropdown-menu dropdown-menu-end">
                      {['modal-sm', 'modal-md', 'modal-lg', 'modal-xl'].map(size => (
                        <li key={size}>
                          <button
                            className={`dropdown-item ${modal.format === size ? 'active' : ''}`}
                            onClick={() =>
                              updateModal({ ...modal, format: size })
                            }
                          >
                            {size.replace('modal-', '').toUpperCase()}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => updateModal({ ...modal, view: false })}
                ></button>
              </div>
            </div>

            {/* BODY */}
            <div className={`modal-body-custom ${modal.styles?.bodyClass ?? ''}`}>
              {visible && children}
            </div>

            {/* FOOTER */}
            <div className={`modal-footer ${modal.styles?.footerClass ?? ''}`}>
              <div className="ms-auto d-flex gap-2">
                {buttonsAddFooter}

                {modal.btnClose && (
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => updateModal({ ...modal, view: false })}
                  >
                    Cerrar
                  </button>
                )}

                {modal.btnSubmit && eventModal && (
                  <button
                    type="button"
                    className={`btn ${modal.styles?.buttonClass ?? "btn-primary"}`}
                    onClick={eventModal}
                  >
                    {onSubmitLabel ?? 'Guardar'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" style={{ zIndex: zIndex }}></div>
    </>
  );

  return createPortal(modalContent, document.body);
};
